/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React from 'react';
import { FieldSetWrapper } from './FieldWrapper';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import componentTypes from '@data-driven-forms/react-form-renderer/dist/cjs/component-types';
import clsx from 'clsx';
interface CheckboxInputProps {
  className?: string;
  colorType?: 'default' | 'blue';
  disabled?: boolean;
  checked?: boolean;
}
export const CheckboxInput = ({
  className = '',
  colorType = 'default',
  ...props
}: CheckboxInputProps & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => {
  return (
    <div
      className={clsx(
        'field-with-icons rounded w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 relative p-1',
        props.disabled && 'opacity-50 cursor-default',
        props.checked && colorType === 'blue' ? 'bg-blue-80' : '',
        className
      )}
    >
      <input type='checkbox' data-testid='checkboxinput-input' className='opacity-0 absolute h-full w-full' {...props} />
      <svg
        viewBox='0 0 20 20'
        className={clsx(
          'fill-current w-5 h-5 text-primary-500 pointer-events-none',
          !props.checked && 'hidden',
          colorType === 'blue' && 'fill-white'
        )}
      >
        <path d='M0 11l2-2 5 5L18 3l2 2L7 18z' />
      </svg>
    </div>
  );
};
export function Checkbox({ name, label, initialValue }) {
  const { input } = useFieldApi({
    name,
    type: 'checkbox',
    component: componentTypes.CHECKBOX,
    initialValue
  });
  return (
    <FieldSetWrapper name={name}>
      <div className='h-12 flex items-center space-x-3'>
        <label className='flex justify-start items-start'>
          <CheckboxInput {...input} />
          <div className='font-effra text-black-default block tracking-wide text-gray-700 text-sm font-normal mb-2'>
            {label}
          </div>
        </label>
      </div>
    </FieldSetWrapper>
  );
}
export default Checkbox;